import { render, staticRenderFns } from "./PedagioListagem.vue?vue&type=template&id=426ae154&scoped=true&"
import script from "./PedagioListagem.vue?vue&type=script&lang=js&"
export * from "./PedagioListagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426ae154",
  null
  
)

export default component.exports